import { render } from "./legoArea.vue?vue&type=template&id=2eb95b04"
import script from "./legoArea.vue?vue&type=script&lang=js"
export * from "./legoArea.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/lego-component/components/layout/legoArea/legoArea.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2eb95b04"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2eb95b04', __exports__)) {
    api.reload('2eb95b04', __exports__)
  }
  
  module.hot.accept("./legoArea.vue?vue&type=template&id=2eb95b04", () => {
    api.rerender('2eb95b04', render)
  })

}


export default __exports__